module.exports = __webpack_public_path__ + "static/media/header-name.d25ab143.svg";